<template>
  <button
    :class="[textButton === false ? os === 'iOS' ? 'apps-store' : os === 'AndroidOS' ? 'play-store' : 'desktop-logo' : '', overlay ? 'button-overlay' : '']"
    class="vs-btn-legacy banner-download__download-app"
    :tracker="tracker"
    @click="clickButton"
  >
    <slot />
  </button>
</template>

<script>
import BrowserDetector from '@/scripts/helpers/browser-detector';
import analytic from '@/scripts/libs/analytic';

export default {
  props: {
    textButton: {
      type: Boolean,
      default: true,
    },
    overlay: {
      type: Boolean,
      default: false,
    },
    tracker: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      os: '',
    };
  },
  created() {
    this.os = BrowserDetector.os();
  },
  methods: {
    clickButton() {
      if (this.os === 'AndroidOS') {
        window.open(
          'https://play.google.com/store/apps/details?id=com.viddsee',
          '_blank',
        );
      } else if (this.os === 'iOS') {
        window.open(
          'https://itunes.apple.com/app/viddsee-watch-asian-movies/id930821146',
          '_blank',
        );
      } else {
        window.open(
          'https://www.viddsee.com/',
          '_blank',
        );
      }
      if (this.tracker) {
        analytic.send(this.tracker);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.play-store {
  background-image: url('~@/images/banner/download-google-play.png');
}
.apps-store {
  background-image: url('~@/images/banner/download-app-store.svg');
}
.desktop-logo {
  background-image: url('~@/images/banner/download-unknown.png');
}
.button-overlay{
  background-image: linear-gradient(to right, white 0%, #fbd3e2  50%, white 100%);
  background-position: left center;
  background-size: 800% auto;
  transition: background-position 0.8s;

  color: #e61762;
  font-weight: 600;
  border-radius: 99em;
  animation-name: shine-in-out;
  animation-duration: 2s;
  width: auto;
  padding: 1em;
  margin: 12px auto 0;

  &:hover {
    color:darken(#fbd3e2, 1.01);
  }

  &:focus {
    background-position: center center;
  }

  @keyframes shine-in-out {
    0% { background-position: right center; }
    100% { background-position: left center; }
  }
}
</style>
